var _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9995C2.00093 6.47767 6.47738 2 12.0005 2C17.5238 2 22 6.47767 22 11.9995C22 17.5223 17.5236 21.9991 12.0005 22C6.47715 21.9991 2.00095 17.523 2 11.9995V11.9995ZM3.73832 11.9995C3.74851 16.5615 7.438 20.2526 11.9995 20.2609C16.562 20.2525 20.2524 16.5615 20.2597 11.9995C20.2523 7.43845 16.562 3.74742 11.9995 3.73913C7.43895 3.74746 3.74851 7.43845 3.73832 11.9995Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.15,
    cy: 12.15,
    r: 1.15,
    fill: "currentColor",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.15,
    cy: 12.15,
    r: 1.15,
    fill: "currentColor",
    fillOpacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.15,
    cy: 12.15,
    r: 1.15,
    fill: "currentColor",
    fillOpacity: 1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.71cba663.svg";
export { ForwardRef as ReactComponent };